<script lang="ts">
    import {createEventDispatcher} from "svelte";

    export let label: string = '';
    export let slug: string;
    export let active: boolean = false;

</script>
<div class="border-bottom py-1 box-b" on:click>
    <p>{label}</p>
    <div>
        {#if active}
            <img height="24" width="24" src="/static/storefront/pix/material/radio_button_checked.svg" alt="Checked">
        {:else}
            <img height="24" width="24" src="/static/storefront/pix/material/radio_button_unchecked.svg" alt="No Checked">
        {/if}
    </div>
</div>